import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, startWith, switchMap } from 'rxjs/operators';
import { PosicaoNcmService } from '../../../service/posicao-ncm.service';

@Component({
  selector: 'app-autocomplete-posicao-ncm',
  templateUrl: './autocomplete-posicao-ncm.component.html',
  styleUrls: ['./autocomplete-posicao-ncm.component.scss'],
  providers: [MaskPipe]
})
export class AutocompletePosicaoNcmComponent implements OnInit, OnDestroy {
  @Input()
  idPleito: number;

  @Input()
  label: string = 'NCM/TIPI do Anexo do Decreto';

  @Input()
  controlName: string;

  @Input()
  exibeBotaoLimpar: boolean = true;

  @Output()
  selecionar: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  limpar: EventEmitter<string> = new EventEmitter<string>();

  posicoesNcm: string[];
  autocompleteSubscription: Subscription;
  opcaoSelecionada: boolean = false;

  private formControl: FormControl;
  private mascaraSubscription: Subscription;

  constructor(
    private readonly maskPipe: MaskPipe,
    private readonly posicaoNcmService: PosicaoNcmService,
    private readonly controlContainer: ControlContainer
  ) {
  }

  ngOnInit(): void {
    this.formControl = this.controlContainer.control.get(this.controlName) as FormControl;
    this.mascaraSubscription = this.formControl.valueChanges.subscribe(value => {
      if (value && !this.opcaoSelecionada) {
        this.formControl.setValue(this.maskPipe.transform(value, '0000.00.00'), { emitEvent: false });
      }
    });
    this.posicoesNcm = [];
    this.initAutocomplete();
  }

  ngOnDestroy(): void {
    this.autocompleteSubscription.unsubscribe();
    this.mascaraSubscription.unsubscribe();
  }

  validarInput(event: KeyboardEvent): void {
    const input = event.key;
    const valor = this.formControl.value;
    const length = valor !== null && valor !== undefined ? valor.length : 0;

    if ((length === 4 || length === 7) && input !== '.' && input !== 'Backspace') {
      event.preventDefault();
      this.formControl.setValue(`${valor}.${input}`, { emitEvent: true });
    }
  }

  selecionarPosicao($event: MatAutocompleteSelectedEvent): void {
    this.opcaoSelecionada = true;
    this.formControl.patchValue($event.option.value);
    this.formControl.disable();
    this.selecionar.emit($event.option.value);
  }

  limparPosicao(): void {
    const posicao: string = this.formControl.value;
    this.formControl.patchValue(null);
    this.formControl.enable();
    this.posicoesNcm.length = 0;
    this.limpar.emit(posicao);
    this.opcaoSelecionada = false;
  }

  exibirPosicaoNcm(posicaoNcm: string): string {
    return posicaoNcm;
  }

  private initAutocomplete(): void {
    this.autocompleteSubscription = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      filter(numero => numero && numero.length >= 2),
      switchMap(numero => this.posicaoNcmService.obterPorNumero(this.idPleito, numero))
    ).subscribe(posicoes => {
      this.posicoesNcm = posicoes;
      this.validarPosicaoInvalida();
    });
  }

  private validarPosicaoInvalida() {
    this.formControl.setErrors(null);

    if (this.posicoesNcm.length === 0) {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
      this.formControl.setErrors({MSG113: true});
    }
  }

}
